import { useState } from "react";
import { useAdvancedPanelData } from "../useAdvancePanelData";
import { Text } from "./Text";

interface TextListProps {
  handleChange: () => void;
  objectId: string;
}

export default function TextList({ handleChange, objectId }: Readonly<TextListProps>) {
  const { texts } = useAdvancedPanelData(objectId);
  const [currentActiveText, setCurrentActiveText] = useState<string | null>(null);

  return (
    <>
      {texts.map((data) => (
        <Text
          key={data.key}
          data={data}
          onChange={handleChange}
          onFocus={() => setCurrentActiveText(data.key)}
          active={currentActiveText === data.key}
        />
      ))}
    </>
  );
}
